var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-article-list__filters hiq-search-filters"},[_c('span',{staticClass:"show-for-sr"},[_vm._v(" Filtrera på:")]),_c('date-picker-filter'),_vm._l((_vm.tags),function(tag){return _c('tag-filter',{key:tag.name,attrs:{"tag":tag}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }